import React, { useState, useMemo }  from "react";
import Label from "components/general/Label"
import SportCode from "components/common/SportCode"
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Stack from 'react-bootstrap/Stack';

function getInitialCurrentHole(participant, unitData){
  const participantData = unitData?.results?.items?.find(r => r.participant.code === participant);
  const current_hole = participantData?.extendedResults?.find(er => er.er_code === 'CURRENT')?.er_value;
  return (current_hole) 
    ? current_hole
    : "1"
}

const PlayOffPlayByPlay = ({participant, unitData} ) => {
  const [currentHole, setCurrentHole] = useState(getInitialCurrentHole(participant, unitData));
  const [currentMetric, setMetric] = useState("metric")
  
    return (
    <>
      <ButtonToolbar>
        <ButtonGroupHole currentHole={currentHole} setCurrentHole={setCurrentHole} unitData={unitData}/>
        <ButtonGroupMetric currentMetric={currentMetric} setMetric={setMetric}/>
      </ButtonToolbar>

      <Stack className="mt-1 border" direction="horizontal">
        <HoleInfo currentHole={currentHole} unitData={unitData}/>
        <HoleShots participant={participant} currentHole={currentHole} unitData={unitData} currentMetric={currentMetric}/>
        <div className="ms-auto"></div>
      </Stack>
    </>
  )
};

export default PlayOffPlayByPlay;

const HoleInfo = ({currentHole, unitData} ) => {
  const hole = unitData?.results?.extendedInfos.find(ei => ei.ei_code === 'PLAYOFF' && ei.ei_pos === currentHole)?.ei_value
  const par = unitData?.config?.extendedConfig?.find(hole => hole.code === 'HOLE' && hole.pos === hole)?.value
  return(
    <>
      <Stack direction="vertical" className="align-items-start">
        <strong><Label data="HeaderHole"/> {hole} - <Label data="HeaderPar"/> {par}</strong>
      </Stack>
    </>
  )
};

const HoleShots = ({participant, currentHole, unitData, currentMetric} ) => {
  return(
    <>
      <Stack direction="vertical" className="align-items-start">
        {
          unitData?.results?.playByPlay
            ?.find(pbp => pbp?.actions.find(a=> a.pbpa_period===`${participant}HOLE_${currentHole.padStart(2, '0')}`))
            ?.actions
            .sort(({ pbpa_order: prevOrder }, { pbpa_order: currOrder }) => prevOrder - currOrder)
            .map(action =>{
              const shot = action.pbpa_order;
              const action_add = action.pbpa_ActionAdd;
              const from_loc = action?.extendedActions.find(ea => ea.pbpea_code === 'FROM_LOC')?.pbpea_value;
              const from_enh = action?.extendedActions.find(ea => ea.pbpea_code === 'FROM_ENH')?.pbpea_value;
              const fairway_center_m = action?.extendedActions.find(ea => ea.pbpea_code === 'FAIRWAY_CENTER' && ea.pbpea_pos === '0')?.pbpea_value;
              const fairway_center_y = action?.extendedActions.find(ea => ea.pbpea_code === 'FAIRWAY_CENTER' && ea.pbpea_pos === '1')?.pbpea_value;
              const fairway_edge_m = action?.extendedActions.find(ea => ea.pbpea_code === 'FAIRWAY_EDGE' && ea.pbpea_pos === '0')?.pbpea_value;
              const fairway_edge_y = action?.extendedActions.find(ea => ea.pbpea_code === 'FAIRWAY_EDGE' && ea.pbpea_pos === '1')?.pbpea_value;
              const dtp_m = action?.extendedActions.find(ea => ea.pbpea_code === 'DTP' && ea.pbpea_pos === '0')?.pbpea_value;
              const dtp_y = action?.extendedActions.find(ea => ea.pbpea_code === 'DTP' && ea.pbpea_pos === '1')?.pbpea_value;
              
              return(
                <div key={`pbp-${participant}-${currentHole}-${shot}`}>
                  <Label data="HeaderShot"/> {shot} -
                  {
                    (action_add === "DRP" || action_add === "PTY")
                      ? <SportCode code={action_add} discipline="GLF" entity="@StrokeType" />
                      : (dtp_m === '0.00' || dtp_m === '0') 
                        ? <SportCode code="CUP" discipline="GLF" entity="@StrokeLocation" />
                        : (
                          <>
                          {(from_loc) ? (
                            <><SportCode code={from_loc} discipline="GLF" entity="@StrokeLocation" /></>
                          ) : ''}
                          {(from_enh) ? (
                            <>,&nbsp;<SportCode code={from_enh} discipline="GLF" entity="@EnhancedStrokeLocation" /></>
                          ) : ''}
                          {(currentMetric === 'metric')
                            ? (
                              <>
                              {(fairway_center_m) ? (
                                <>&nbsp;,{fairway_center_m}&nbsp;<Label data="LabelMeters"/>&nbsp;<Label data="LabelFromFairwayCenter"/></>
                              ) : ''}
                              {(fairway_edge_m) ? (
                                <>&nbsp;,{fairway_edge_m}&nbsp;<Label data="LabelMeters"/>&nbsp;<Label data="LabelFromFairwayEdge"/></>
                              ) : ''}
                              {(dtp_m) ? (
                                <>&nbsp;,{dtp_m}&nbsp;<Label data="LabelMeters"/>&nbsp;<Label data="LabelFromHole"/></>
                              ) : ''}                                                                            
                              </>
                            ) : (
                              <>
                              {(fairway_center_y) ? (
                                <>&nbsp;{fairway_center_y}&nbsp;<Label data="LabelYards"/>&nbsp;<Label data="LabelFromFairwayCenter"/></>
                              ) : ''}
                              {(fairway_edge_y) ? (
                                <>&nbsp;{fairway_edge_y}&nbsp;<Label data="LabelYards"/>&nbsp;<Label data="LabelFromFairwayEdge"/></>
                              ) : ''}
                              {(dtp_y) ? (
                                <>&nbsp;{dtp_y}&nbsp;<Label data="LabelYards"/>&nbsp;<Label data="LabelFromHole"/></>
                              ) : ''}                                                                            
                              </>
                            )                        
                          }
                          </>
                        )
                  }
                </div>
              )
            })
        }
        <div className="p-1">
        </div>	
      </Stack>
  </>
  )
};

const ButtonGroupMetric = ({ currentMetric, setMetric }) => {
  const types = [
    { type: 'metric', label: <Label data="HeaderMetric" /> }, 
    { type: 'imperial', label: <Label data="HeaderImperial" /> }
  ];

  const handleClick = (e) => {
      setMetric(e.target.value)
  }
  return (
      <ButtonGroup size="sm" className="align-items-end" onClick={handleClick}>
          {types.map((obj, index) => (
              <Button key={`btn-measureunit-${index}`} className="selector" variant="outline-dark" active={currentMetric === obj.type} value={obj.type} >{obj.label}</Button>
          ))}
      </ButtonGroup>
  );
}

const ButtonGroupHole = ({ currentHole, setCurrentHole, unitData }) => {
  const handleClick = (e) => {
    setCurrentHole(e.target.value)
  }
  return (
    <>
      <Stack direction="vertical" className="align-items-start">
        <div className="text-left"><strong><Label data="HeaderHole"/></strong></div>
        <div>
        <ButtonGroup size="sm" className="me-2" aria-label="Hole" >
          {
              unitData?.results?.extendedInfos.filter(ei => ei.ei_code === 'PLAYOFF').map((hole) => {
                return(
                  <Button key={`btn-hole-${hole.ei_pos}`} active={currentHole===hole.ei_pos} variant="outline-dark" onClick={handleClick} value={hole.ei_pos}>{hole.ei_value}</Button>
                )
              })
          }          
        </ButtonGroup>
        </div>
      </Stack>
    </>
  );
}
